define([
    'prop-types',
    'lodash',
    'utils',
    'santaProps/utils/propsSelectorsUtils'
], function (PropTypes, _, utils, propsSelectorsUtils) {
    'use strict';

    const createComponentSantaType = propsSelectorsUtils.createComponentSantaType;

    const styleIdBySkin = function (skinName) {
        return createComponentSantaType(PropTypes.string, function () {
            return utils.santaTypes.shortenStyleId(skinName);
        });
    };

    return {
        styleIdBySkin
    };
});
